import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-324efc22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Item__Inner" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "Item__Metas small-uppercase color--2" }
const _hoisted_5 = { class: "Item__Chapters" }
const _hoisted_6 = { class: "Item__Duration" }
const _hoisted_7 = {
  key: 0,
  class: "color--2"
}
const _hoisted_8 = { class: "small-uppercase color--2" }
const _hoisted_9 = { class: "Item__Restriction color--2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 21 21" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-locked" })
], -1))
const _hoisted_11 = { class: "Item__Visual__Subinner" }
const _hoisted_12 = {
  key: 0,
  class: "Item__Visual__Picture"
}
const _hoisted_13 = { class: "round-in-scroll" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Item__Visual__Placeholder active" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "Item__Visual__Placeholder__Inner round-in-scroll" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "black" })
  ])
], -1))
const _hoisted_15 = {
  key: 1,
  class: "Item__Visual__Picture"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Item__Visual__Placeholder__Inner round-in-scroll" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color--5" }),
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 60 116",
    class: "color--1 round-in-scroll__up"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-keyhole" })
  ])
], -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Progress = _resolveComponent("Progress")!
  const _component_LazyPicture = _resolveComponent("LazyPicture")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([ 'Item', (_ctx.current === _ctx.course) ? 'active' : '', _ctx.hidden ? 'is-hidden' : '', (_ctx.isAppear) ? 'is-appear' : '', (_ctx.isShown) ? 'is-shown' : '' ] )
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.course.status === 'opened')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            "data-course-index": _ctx.index,
            to: _ctx.course.type === 'course' ? `/course/${_ctx.course.slug}` : `/test/${_ctx.course.slug}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("h2", {
                class: _normalizeClass('theme--' + _ctx.course.theme)
              }, [
                _createElementVNode("div", {
                  class: "color--2",
                  innerHTML: _ctx.itemTitle,
                  ref: "title"
                }, null, 8, _hoisted_2)
              ], 2)
            ]),
            _: 1
          }, 8, ["data-course-index", "to"]))
        : (_openBlock(), _createElementBlock("h2", {
            key: 1,
            class: _normalizeClass('theme--' + _ctx.course.theme)
          }, [
            _createElementVNode("div", {
              class: "color--2",
              innerHTML: _ctx.itemTitle,
              ref: "title"
            }, null, 8, _hoisted_3)
          ], 2)),
      (_ctx.course.status === 'opened')
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["Item__Footer", 'theme--' + _ctx.course.theme])
          }, [
            (_ctx.course.type === 'course')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("ul", _hoisted_4, [
                    _createElementVNode("li", _hoisted_5, _toDisplayString(_ctx.course.nbChapters >= 2 ? _ctx.$t('course.chapters', { nb: _ctx.course.nbChapters }) : _ctx.$t('course.chapter', { nb: _ctx.course.nbChapters })), 1),
                    _createElementVNode("li", _hoisted_6, _toDisplayString(_ctx.readTime), 1)
                  ]),
                  _createVNode(_component_Progress, {
                    value: _ctx.course.progress,
                    class: "Item__Progress color--2"
                  }, null, 8, ["value"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.course.type === 'test')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_ctx.course.success)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.tryMessage), 1))
                    : _createCommentVNode("", true),
                  (_ctx.course.success)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("course.best")), 1),
                        _createVNode(_component_Progress, {
                          value: _ctx.course.progress,
                          class: "Item__Progress color--2",
                          type: "score"
                        }, null, 8, ["value"])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.course.status === 'closed')
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(["Item__Footer", 'theme--' + _ctx.course.theme])
          }, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", null, _toDisplayString(_ctx.lockedMessage), 1)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['Item__Visual', 'Item__Visual--'+_ctx.course.status]),
      style: _normalizeStyle(`transform: rotate(${ ((_ctx.index * _ctx.gap) - _ctx.rotation) }deg);`),
      ref: "visual"
    }, [
      _createElementVNode("div", {
        class: "Item__Visual__Inner",
        style: _normalizeStyle(`transform: scale(${this.scale})`)
      }, [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.course.status === 'opened')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.course.image?.url || _ctx.course.type === 'test')
                    ? (_openBlock(), _createBlock(_component_LazyPicture, {
                        key: 0,
                        image: _ctx.itemImage,
                        alt: _ctx.course.title,
                        imgClass: "round-in-scroll__down",
                        lazy: false
                      }, null, 8, ["image", "alt"]))
                    : _createCommentVNode("", true),
                  _hoisted_14
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.course.status === 'closed')
            ? (_openBlock(), _createElementBlock("picture", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (c) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'Item__Visual__Placeholder--'+c.slug,
                    class: _normalizeClass([['theme--' + c.theme, _ctx.current === c ? 'active' : ''], "Item__Visual__Placeholder"])
                  }, _hoisted_17, 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ], 4)
    ], 6)
  ], 2))
}